import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const CONTENT_PERMISSIONS = {
  WRITE: PERMISSIONS.CONTENT_WRITE,
};

export const CONTENT_QUERY_KEYS = queryKeys.content;

export const LEGAL_PORTALS = {
  BUYER: 'BUYER',
  SUPPLIER: 'SUPPLIER',
};

export const LEGAL_TYPES = {
  TERMS: 'TERMS',
  PRIVACY: 'PRIVACY',
};

export const LEGAL_SLOTS = [
  { portal: LEGAL_PORTALS.BUYER, type: LEGAL_TYPES.TERMS },
  { portal: LEGAL_PORTALS.BUYER, type: LEGAL_TYPES.PRIVACY },
  { portal: LEGAL_PORTALS.SUPPLIER, type: LEGAL_TYPES.TERMS },
  { portal: LEGAL_PORTALS.SUPPLIER, type: LEGAL_TYPES.PRIVACY },
];

export const FOOTER_NETWORKS = {
  YOUTUBE: 'YOUTUBE',
  INSTAGRAM: 'INSTAGRAM',
  LINKEDIN: 'LINKEDIN',
  X: 'X',
};

export const FOOTER_PAGE_GROUPS = {
  COMPANY: 'COMPANY',
  LEGAL: 'LEGAL',
};
